import { render, staticRenderFns } from "./EstadisticasPersonales.vue?vue&type=template&id=6aed3b04&"
import script from "./EstadisticasPersonales.vue?vue&type=script&lang=js&"
export * from "./EstadisticasPersonales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports